import { AwesomeButton } from "react-awesome-button";
import { Fade } from "react-awesome-reveal";
import { BsDiscord, BsGithub, BsLinkedin, BsTelegram, BsTwitter } from "react-icons/bs";
import { socialLinks } from "../data/socialLinks";

export default function Contact() {
  return (
    <div className="flex flex-col bg-gradient-to-br from-dark-bg-950 via-dark-bg-900 to-dark-bg-950 dark:bg-hero-pattern px-3 h-full overflow-x-hidden overflow-y-auto transition-all duration-300">
      <div className="flex flex-col justify-center items-center gap-10 mt-24 md:mt-2 mb-[80px] md:mb-2 w-full md:min-h-full">
        <div className="relative flex flex-col justify-center items-center gap-10 max-w-[650px] text-left">
          <Fade delay={800} triggerOnce={true}>
            <div className="p-2 min-h-[120px] center">
              <div className="relative p-2">
                <img src="imgs/rusty.png" className="rounded-full w-[120px] border-2 border-accent-400/30" alt="Rusty - Full Stack & Blockchain Developer" />
              </div>
            </div>
          </Fade>
          <Fade delay={1000} triggerOnce={true}>
            <h1 className="font-bold text-white text-[2em] md:text-[2.625em] uppercase font-inter">
              <span className="bg-gradient-to-r from-accent-400 via-purple-accent-400 to-accent-500 bg-clip-text text-transparent">
                Get in touch
              </span>
            </h1>
          </Fade>
          <Fade
            delay={1300}
            triggerOnce={true}
            className="flex justify-center items-center w-full text-center"
          >
            <div className="text-center">
              <p className="text-gray-200 text-lg font-inter leading-relaxed font-medium">
                For business inquiries, project proposals, or professional discussions, please reach out via email:
              </p>
              <a
                href="mailto:rusty.engineer.1210@gmail.com"
                className="text-accent-400 hover:text-purple-accent-400 text-xl font-bold transition-all duration-300 hover:underline"
              >
                rusty.engineer.1210@gmail.com
              </a>
              <p className="text-gray-200 text-lg font-inter leading-relaxed font-medium mt-2">
                I typically respond within 24 hours and look forward to connecting with you.
              </p>
            </div>
          </Fade>
          <Fade delay={1700} triggerOnce={true}>
            <h1 className="font-bold text-white text-[1.25em] uppercase font-inter">
              <span className="bg-gradient-to-r from-purple-accent-400 via-accent-400 to-purple-accent-500 bg-clip-text text-transparent">
                Let's get social
              </span>
            </h1>
           
          </Fade>

          <Fade delay={1900} triggerOnce={true}>
            <div className="justify-center items-center gap-5 grid grid-cols-2 md:grid-cols-4">
              {/* <AwesomeButton type="twitter" href={socialLinks.twitter}>
                <span className="flex justify-center items-center gap-1">
                  <BsTwitter size={20} />
                  <span className="font-light text-sm uppercase">Twitter</span>
                </span>
              </AwesomeButton> */}
              <a
                href={socialLinks.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex justify-center items-center gap-2 px-4 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600 text-white font-semibold rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-glow"
              >
                <BsLinkedin size={20} />
                <span className="font-medium text-sm uppercase">LinkedIn</span>
              </a>
              <a
                href={socialLinks.discord}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex justify-center items-center gap-2 px-4 py-3 bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-500 hover:to-purple-600 text-white font-semibold rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-glow-purple"
              >
                <BsDiscord size={20} />
                <span className="font-medium text-sm uppercase">Discord</span>
              </a>
              <a
                href={socialLinks.github}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex justify-center items-center gap-2 px-4 py-3 bg-gradient-to-r from-gray-700 to-gray-800 hover:from-gray-600 hover:to-gray-700 text-white font-semibold rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-glow"
              >
                <BsGithub size={20} />
                <span className="font-medium text-sm uppercase">GitHub</span>
              </a>
              <a
                href={socialLinks.telegram}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex justify-center items-center gap-2 px-4 py-3 bg-gradient-to-r from-accent-600 to-purple-accent-600 hover:from-accent-500 hover:to-purple-accent-500 text-white font-semibold rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-glow-purple"
              >
                <BsTelegram size={20} />
                <span className="font-medium text-sm uppercase">Telegram</span>
              </a>
            </div>
          </Fade>
        </div>
      </div>
    </div>
  );
}
